import { ErrorIllustration, StatusScreen, CopyButton } from "@kaltura/mediaspace-shared-ui";
import { Button, Typography } from "@kaltura/ds-react-components";
import styled from "@emotion/styled";

export interface ExceptionInformation {
    title: string;
    message: string;
    traceLabel: string;
    trace: string;
    requestLabel: string;
    request: string;
}

export interface ErrorPageProps {
    title: string;
    text: string;
    sessionDataLabel?: string;
    sessionData?: string;
    buttonLabel?: string;
    toolTipLabel: string;
    exceptionInformation?: ExceptionInformation;
}

const StyledH3 = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));

const StyledPre = styled("pre")(({ theme }) => ({
    backgroundColor: theme.kaltura.palette.tone7,
    border: "1px solid",
    borderColor: theme.kaltura.palette.tone5,
    borderRadius: theme.kaltura.shape.roundness1,
    padding: theme.spacing(1, 2, 1, 2),
    wordBreak: "break-all",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    fontSize: theme.typography.fontSize,
}));

/**
 * general error screen
 */
const ErrorPage = (props: ErrorPageProps) => {
    const { title, text, sessionDataLabel, sessionData, buttonLabel, toolTipLabel, exceptionInformation } = props;

    let displayText = text;
    displayText += sessionData ? `<br/><br/><b>${sessionDataLabel}</b>${sessionData}` : "";

    return (
        <>
            <StatusScreen
                title={title}
                text={displayText}
                image={<ErrorIllustration />}
                customButton={
                    sessionData && buttonLabel ? (
                        <CopyButton text={sessionData} toolTipLabel={toolTipLabel}>
                            <Button size="large">{buttonLabel}</Button>
                        </CopyButton>
                    ) : undefined
                }
                contentWidth={784}
            />
            {exceptionInformation && (
                <>
                    <StyledH3 component="h2" variant="h3">
                        {exceptionInformation.title}
                    </StyledH3>
                    <Typography variant="body1">{exceptionInformation.message}</Typography>
                    <StyledH3 component="h2" variant="h3">
                        {exceptionInformation.traceLabel}
                    </StyledH3>
                    <StyledPre>{exceptionInformation.trace}</StyledPre>
                    <StyledH3 component="h2" variant="h3">
                        {exceptionInformation.requestLabel}
                    </StyledH3>
                    <StyledPre>{exceptionInformation.request}</StyledPre>
                </>
            )}
        </>
    );
};

export default ErrorPage;
